import { render } from "./MarkupLink.vue?vue&type=template&id=b5aa27e0&scoped=true"
import script from "./MarkupLink.vue?vue&type=script&lang=js"
export * from "./MarkupLink.vue?vue&type=script&lang=js"

import "./MarkupLink.vue?vue&type=style&index=0&id=b5aa27e0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5aa27e0"]])

export default __exports__